export default __webpack_public_path__ + "static/media/IskoolaPota.17c45212.woff";